import React from 'react';
import * as ReactDOM from 'react-dom/client';
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import PageHeader from "../../components/PageHeader/PageHeader.js";
import GlsDpm from "../../components/GlsDpm/GlsDpm.js";
import Form from '../Forms/Form/Form.js';

import './CheckoutDelivery.css'; 

class CheckoutDelivery extends React.Component {
   
  emptyFormData = {
    delivery_method: null,
    select_reservation_selected_shop: 0,
  };

  emptyFormErrors = {
    /*
    delivery_method: 'Teszt hibaüzenet delivery_method',
    summary: 'Teszt hibaüzenet summary',*/
    delivery_method: '',
    summary: '',
    reservation_shop: i18n.t('reservationErrorSelectShop'),
  };

  settings = {};

  parent = null;

  glsMapData = {};

  select_reservation_selected_shop = 0;

  drop_point_types = ['gls_drop_point'];

  show_address_form_types = ['delivery_address', 'same_day_delivery'];

  constructor(props) {
    super(props);
    
    this.state = {
      show: false,
      hiding: false,
      formData: { ...this.emptyFormData },
      formErrors: { ...this.emptyFormErrors },
      checkoutSummary: {},
      checkoutStepData: {},

      is_gls_drop_point: false,
      show_address_form: false,
      foxPostMapData: {
        select_foxpost_place_id: '',
        select_foxpost_operator_id: '',
        select_foxpost_name: '',

        select_foxpost_address: '',
      }
    };
  }

  componentDidMount() {
    window.addEventListener('message', this.foxPostMessageReceiver, false);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.foxPostMessageReceiver);
  }

  foxPostMessageReceiver = (event) => {
    const { foxPostMapData } = this.state;

    if(event.data !== undefined) {
      try {
        var apt = null;

        if(typeof event?.data === 'string') {
          apt = JSON.parse(event.data);
        }
        else if (typeof event.data === 'object') {
          apt = event.data; // <--- HA MÁR OBJEKTUM, AKKOR SIMÁN ÁTVESSZÜK
        }
        
        if (apt && apt.place_id !== undefined) {
          this.setState({foxPostMapData: {
            select_foxpost_place_id: String(apt.place_id),
            select_foxpost_operator_id: apt.operator_id || '',
            select_foxpost_name: apt.name || '',
            select_foxpost_address: apt.address || '',
          }}); 
        }
      }
      catch (e) {
        console.error('Foxpost handler error:', e);
      }
    }
  }

  show(parent = null) {
    this.parent = parent;

    let { formData } = this.state;

    window.AppRef.current.get_settings().then((resp)=>{
      this.settings = resp.settings;

      formData.delivery_method = parseInt(this.parent.state.paymentDeliveryMethods.delivery_method_id);
      formData.select_reservation_selected_shop = parseInt(this.parent.state.fullCheckoutForm.values.select_reservation_selected_shop);

      let show_address_form = false;
      let is_gls_drop_point = false;
      
      if (formData.delivery_method)
      {
        is_gls_drop_point = this.drop_point_types.includes(this.parent.state.paymentDeliveryMethods?.delivery_methods[formData.delivery_method]?.delivery_method_type);
        show_address_form = this.show_address_form_types.includes(this.parent.state.paymentDeliveryMethods?.delivery_methods[formData.delivery_method]?.delivery_method_type) || 
          ['reservation', 'reservation_with_transport'].includes(this.parent.state.paymentDeliveryMethods?.delivery_methods[formData.delivery_method]?.delivery_method_reservation_type_txt) ;
      }
      
      this.setState({
        show: true, 
        checkoutSummary: this.parent.state, 
        formData: formData, 
        checkoutStepData: this.parent.checkoutStepData.step2,
        show_address_form: show_address_form,
        is_gls_drop_point: is_gls_drop_point,
        reservation_shop_id: null,
      });
    });
  }

  hide() {
    this.setState({hiding: true}, function() {
      setTimeout(() => {
        this.setState({show: false, hiding: false});
      }, 200);
    });
  }

  toggle(parent = null) {
    if (this.state.show)
    {
      this.hide();
    }
    else {
      this.show(parent);
    }
  }

  handle_change(event, formDataKey, options = {}) {
    let { formData, is_gls_drop_point, checkoutSummary, reservation_shop_id } = this.state;

    formData[formDataKey] = event.target.value;
    
    // szállítási cím választása után egyedi funkciók
    if (formDataKey === 'delivery_method')
    { 
      if (typeof options.delivery_method !== 'undefined')
      { 
        if (this.drop_point_types.includes(options.delivery_method.delivery_method_type))
        {
          this.setState({
            formData: formData, 
            is_gls_drop_point: true, 
            show_address_form: false,
            reservation_shop_id: null
          });
        }
        else {
          const show_address_form = this.show_address_form_types.includes(options.delivery_method.delivery_method_type) || ['reservation', 'reservation_with_transport'].includes(options.delivery_method.delivery_method_reservation_type_txt);

          if(!show_address_form) {
            formData.postal_address_int = 0;
          }

          let new_state = {
            formData: formData, 
            is_gls_drop_point: false, 
            reservation_shop_id: null,
            show_address_form: show_address_form, foxPostMapData: {
              select_foxpost_place_id: '',
              select_foxpost_operator_id: '',
              select_foxpost_name: '',
              select_foxpost_address: '',
            }
          };
          
          this.setState(new_state);
        } 

        return;
      }
      else {
        is_gls_drop_point = false;
      }
    }

    this.setState({formData, is_gls_drop_point, reservation_shop_id, foxPostMapData: {
      select_foxpost_place_id: '',
      select_foxpost_operator_id: '',
      select_foxpost_name: '',
      select_foxpost_address: '',
    }}); 
  }

  handle_submit(e) {
    e.preventDefault();
    this.hide();
  }

  handle_gls_map_data_change(mapData) {
    this.glsMapData = mapData;
  }

  set_form_data(formData,callback)
  {
    this.setState({formData:formData},()=>{
      if(typeof callback=='function'){ callback(); }
    });
  }

  /**
   * Szállítási cím form módosítása után fut le
   */
  set_from_data_from_step(step_name,form_data = {},callback = () => {}) {
    let { formData, checkoutSummary } = this.state;

    // a form_data a Form.js-ből érkezik
    form_data.delivery_method_id = parseInt(formData.delivery_method);
    form_data.select_reservation_selected_shop = this.select_reservation_selected_shop;

    if(checkoutSummary.paymentDeliveryMethods?.delivery_methods[form_data.delivery_method_id]?.delivery_method_type === 'foxpost')
    {
      form_data.postal_address_int = 0;
      form_data.postal_city_txt = checkoutSummary.fullCheckoutForm.values.bill_city_txt;
      form_data.postal_name_txt = checkoutSummary.fullCheckoutForm.values.bill_name_txt;
      form_data.postal_street_txt = checkoutSummary.fullCheckoutForm.values.bill_street_txt;
      form_data.postal_zip_txt = checkoutSummary.fullCheckoutForm.values.bill_zip_txt;
    }
    // ha foglalás típusú szállítás és nincs kiválasztott üzlet, akkor nem mentünk
    else if (/*step_name === '1' && */['reservation', 'reservation_with_transport'].includes(checkoutSummary.paymentDeliveryMethods?.delivery_methods[form_data.delivery_method_id]?.delivery_method_reservation_type_txt))
    {
      if (parseInt(form_data.select_reservation_selected_shop) === 0)
      {
        formData.delivery_method_id = form_data.delivery_method_id;
        formData.select_reservation_selected_shop = form_data.select_reservation_selected_shop;

        this.setState({formData});

        return;
      }
      else { 
        form_data.postal_address_int = 0;
        form_data.postal_city_txt = checkoutSummary.fullCheckoutForm.values.bill_city_txt;
        form_data.postal_name_txt = checkoutSummary.fullCheckoutForm.values.bill_name_txt;
        form_data.postal_street_txt = checkoutSummary.fullCheckoutForm.values.bill_street_txt;
        form_data.postal_zip_txt = checkoutSummary.fullCheckoutForm.values.bill_zip_txt;
      }
    }

    form_data.select_gls_shop_code = this.glsMapData.select_gls_shop_code;
    form_data.glsMapData = this.glsMapData;

    form_data.select_foxpost_place_id = this.state.foxPostMapData.select_foxpost_place_id;
    form_data.foxPostMapData = this.state.foxPostMapData;    

    if (this.drop_point_types.includes(checkoutSummary.paymentDeliveryMethods?.delivery_methods[form_data.delivery_method_id]?.delivery_method_type))
    {
      form_data.postal_address_int = 0;
      form_data.postal_city_txt = checkoutSummary.fullCheckoutForm.values.bill_city_txt;
      form_data.postal_name_txt = checkoutSummary.fullCheckoutForm.values.bill_name_txt;
      form_data.postal_street_txt = checkoutSummary.fullCheckoutForm.values.bill_street_txt;
      form_data.postal_zip_txt = checkoutSummary.fullCheckoutForm.values.bill_zip_txt;
    }
    else if (parseInt(form_data.postal_address_int) === 0)
    {
      form_data.postal_city_txt = checkoutSummary.fullCheckoutForm.values.bill_city_txt;
      form_data.postal_name_txt = checkoutSummary.fullCheckoutForm.values.bill_name_txt;
      form_data.postal_street_txt = checkoutSummary.fullCheckoutForm.values.bill_street_txt;
      form_data.postal_zip_txt = checkoutSummary.fullCheckoutForm.values.bill_zip_txt;
    }
    else if (parseInt(form_data.postal_address_int) > 1)
    {
      let address = Object.values(checkoutSummary.deliveryAddresses).filter(address => parseInt(address.id) == parseInt(form_data.postal_address_int));

      if (address.length)
      {
        address = address[0];

        form_data.postal_city_txt = address.postal_city_txt;
        form_data.postal_name_txt = address.postal_name_txt;
        form_data.postal_street_txt = address.postal_street_txt;
        form_data.postal_zip_txt = address.postal_zip_txt;
      }
    }
    
    // a CheckoutDelivery.formData.values értékeinek beállítása, azért kell, hogy az újbóli megnyitáskor a from alkalmazza az előzőleg a CheckoutSummary-nak küldött adatokat
    formData.values = {...form_data}; 
 
    this.setState({formData}, () => {
      this.parent.set_from_data_from_step(step_name,form_data,callback);

      //this.hide();
    });
  }

  onSelectReservationShop(e) {
    const { formData, formErrors } = this.state;
    
    this.select_reservation_selected_shop = e.target.value;
    formData.select_reservation_selected_shop = this.select_reservation_selected_shop;

    if (parseInt(formData.select_reservation_selected_shop) === 0) {
      formErrors.reservation_shop = i18n.t('reservationErrorSelectShop');
    }
    else {
      formErrors.reservation_shop = '';
      formData.select_reservation_selected_shop = 0;
    }

    this.setState({formData: formData, formErrors: formErrors, reservation_shop_id: this.select_reservation_selected_shop});
  }

  showReservation(delivery_method) {
    const { formErrors, reservation_shop_id, formData } = this.state;

    if(Object.keys(delivery_method.reservation_shops).length === 0)
    {
      formErrors.reservation_shop = i18n.t('reservationNoAvailableShop'); 
    }

    return <div className="reservation">
      {this.showSelectedReservationShop()}
      <div className="reservation_content" dangerouslySetInnerHTML={{__html: delivery_method.reservation_content}}></div>
      <div className="reservation_select">
          <div className="select">
            <select defaultValue={formData.select_reservation_selected_shop} onChange={(e) => this.onSelectReservationShop(e)}>
              <option value="0">{i18n.t('reservationSelectShop')}</option>        

              {Object.keys(delivery_method.reservation_shops).map((shop_id) => {
                shop_id = shop_id.replace('_','');
                return <option key={shop_id} value={shop_id}>{this.parent.state.paymentDeliveryMethods.delivery_methods_shops_data[shop_id].label}</option>;
              })}

            </select>
            <ReactSVG src="assets/images/arrow_down.svg" />
          </div>
          {(formErrors.reservation_shop.length) ? <div className="form_error">{formErrors.reservation_shop}</div> : '' }
          {(formErrors.delivery_method.length) ? <div className="form_error">{formErrors.delivery_method}</div> : '' }
      </div> 
    </div>;
  }

  showSelectedReservationShop() {
    const { reservation_shop_id } = this.state;

    if(parseInt(reservation_shop_id) > 0)
    {
      const reservation_shop = this.parent.state.paymentDeliveryMethods.delivery_methods_shops_data[reservation_shop_id];

      return <div className="selected_reservation_shop">
          <div>{i18n.t('reservationSelectedShop')}</div>
          <div><label>{i18n.t('reservationShop')}</label><p>{reservation_shop.label}</p></div>
          <div><label>{i18n.t('reservationAddress')}</label><p>{reservation_shop.address}</p></div>
          <div><label>{i18n.t('reservationOpeningHours')}</label><p dangerouslySetInnerHTML={{__html: reservation_shop.openhours}}></p></div>
      </div>;
    }
    else {
      return '';
    }
  }

  render() {
    const {formData, formErrors, show, hiding, checkoutSummary, is_gls_drop_point, foxPostMapData } = this.state;

    if (!show) return '';

    let same_day_delivery = false;

    if (this.parent.state.paymentDeliveryMethods?.delivery_methods[formData.delivery_method]?.delivery_method_type === 'same_day_delivery') {
      same_day_delivery = true;
    }

    return <div className={`container floating_container page_checkout page_checkout_delivery ${hiding ? 'out' : ''}`}>
          <div className="content">
          
          <PageHeader parent_ref={this} no_close title={i18n.t('checkoutDelivery')} />

          <div className='container_inner'>
            <form className="checkout_methods" onSubmit={(e) => this.handle_submit(e)}>

              {checkoutSummary.paymentDeliveryMethods.delivery_methods_order.map(delivery_method_id => {
                const delivery_method = checkoutSummary.paymentDeliveryMethods.delivery_methods[delivery_method_id];
              //{Object.values(checkoutSummary.paymentDeliveryMethods.delivery_methods).map(delivery_method => {
                let delivery_method_disabled = false;

                if (!!checkoutSummary.shoppingCart.pc_total && checkoutSummary.shoppingCart.pc_total > 3 && ['reservation', 'reservation_with_transport'].includes(delivery_method.delivery_method_reservation_type_txt)) {
                  delivery_method_disabled = true;
                }

                const conditionalProps = {};
                if (delivery_method_disabled) 
                  {
                  conditionalProps.disabled = 'disabled';
                }

                return <div key={`delivery_method_${delivery_method.id}`} className={`field radio delivery_method ${formErrors.delivery_method !== '' ? "error" : ""}`}>
                  <div className="radio">
                    <input  {...conditionalProps} id={`delivery_method_${delivery_method.id}`} checked={parseInt(formData.delivery_method) === parseInt(delivery_method.id)} type="radio" name="delivery_method" value={parseInt(delivery_method.id)} onChange={(e) => this.handle_change(e, 'delivery_method', {delivery_method})} /> 
                    <label htmlFor={`delivery_method_${delivery_method.id}`} className="checkbox_radio_content"><p><b dangerouslySetInnerHTML={{__html: delivery_method.delivery_method}}></b></p><p dangerouslySetInnerHTML={{__html: delivery_method.delivery_content}}></p></label>
                    {delivery_method.delivery_method_type === 'foxpost' && parseInt(formData.delivery_method) === parseInt(delivery_method.id)  ? 
                      <>
                        <iframe class="foxpost_hide_after_select" frameborder="0" loading="lazy" src={`https://cdn.foxpost.hu/apt-finder/v1/app/?lang=${window.AppRef.current.current_lang}`} width="100%" height="600px"></iframe>
                        {foxPostMapData.select_foxpost_place_id.length ?
                          <div id="foxpost_selected_terminal_info">{i18n.t('checkoutFoxPostSelected')}{`${foxPostMapData.select_foxpost_name}, ${foxPostMapData.select_foxpost_address}`}</div>
                        : ''}
                      </>
                    : ''}
                     
                    {delivery_method.delivery_method_type === 'gls_drop_point' && is_gls_drop_point && parseInt(formData.delivery_method) === parseInt(delivery_method.id) 
                      ? <GlsDpm filter_type={parseInt(delivery_method.gls_drop_point_type) == 1 
                        ? 'parcel-shop' 
                        : 'parcel-locker'} 
                      key={is_gls_drop_point} show={is_gls_drop_point} /> : ''}

                      {(delivery_method.delivery_method_reservation_type_txt == 'reservation' && parseInt(formData.delivery_method) === parseInt(delivery_method.id)) ? this.showReservation(delivery_method) : ''}
                      {(delivery_method.delivery_method_reservation_type_txt == 'reservation_with_transport' && parseInt(formData.delivery_method) === parseInt(delivery_method.id)) ? this.showReservation(delivery_method) : ''}

                      {delivery_method_disabled ? <div className="form_error reservation_quantity_limit_error">{i18n.t('reservationLimitError', { count: this.settings.settings.reservation_quantity_limit })}</div> : ''}
                  </div> 
                </div> ;
              })} 

              {(formErrors.delivery_method.length) ? <div className="form_error">{formErrors.delivery_method}</div> : '' } 
            
              {(is_gls_drop_point) ? <button type="button" className="button" onClick={() => this.set_from_data_from_step('2')}>{i18n.t('checkoutSave')}</button> : ''}

              {(checkoutSummary.paymentDeliveryMethods?.delivery_methods[formData.delivery_method]?.delivery_method_type === 'foxpost') ? <button type="button" className="button" onClick={() => this.set_from_data_from_step('2')}>{i18n.t('checkoutSave')}</button> : ''}

              {['reservation', 'reservation_with_transport'].includes(checkoutSummary.paymentDeliveryMethods?.delivery_methods[formData.delivery_method]?.delivery_method_reservation_type_txt) ? <button type="button" className="button" onClick={() => this.set_from_data_from_step('2')}>{i18n.t('checkoutSave')}</button> : ''}
            </form>

            {this.show_delivery_address_fields()}

          </div>

          </div>
      </div>;   
  }

  is_hidden_delivery_address_fields() {
    const {formData, checkoutSummary } = this.state;

    // ha nincs kiválasztott szállítási mód, akkor elrejtjük a szállítási cím formot
    // ha foglalás típusú szállítás és nincs kiválasztott üzlet, akkor elrejtjük a szállítási cím formot

    return typeof formData.delivery_method === 'undefined' ||
      parseInt(formData.delivery_method) == 0 || 
      ['reservation', 'reservation_with_transport'].includes(checkoutSummary.paymentDeliveryMethods?.delivery_methods[formData.delivery_method]?.delivery_method_reservation_type_txt);
  }

  show_delivery_address_fields() {
    const {formData, show_address_form, show } = this.state;

    if (!show || !show_address_form) return '';
    
    let form_class = this.is_hidden_delivery_address_fields() ? 'hidden' : '';

    return <div className={`delivery_address_fields ${form_class}`}>
      <Form 
        key={formData.form_hash}
        name="checkout_delivery" 
        form_data={formData} 
        form_source="props" 
        on_save={(form_data,callback)=>{this.set_from_data_from_step('2',form_data,callback)}} 
        submit_text={i18n.t('save')} 
        parent={this} />
    </div>;
  }
}

export default CheckoutDelivery;
